import { Dispatch, SetStateAction, useState } from 'react'
import Modal from 'components/Modal/Modal'
import Box from '@mui/material/Box'
import * as yup from 'yup'
import Input from 'components/Input/Input'
import { useTranslation } from 'react-i18next'
import { Form, Formik } from 'formik'
import { useServiceAreas } from 'providers/ServiceAreasProvider'
import { CoordinatesSchema } from 'lib/utils'

type ImportVectorModalProps = {
  handleCloseVectorModal: () => void
  importVectorModal: {
    right: boolean
  }
  setImportVectorModal: Dispatch<SetStateAction<{ right: boolean }>>
  setIsEditing: Dispatch<SetStateAction<boolean>>
}

export const ImportVectorModal = ({
  handleCloseVectorModal,
  setImportVectorModal,
  importVectorModal,
  setIsEditing,
}: ImportVectorModalProps) => {
  const { t } = useTranslation()
  const {
    coordinates,
    setCoordinates,
    selectedDeliveryArea,
    setSelectedDeliveryArea,
  } = useServiceAreas()
  const [isLoadingCoordinates, setIsLoadingCoordinates] = useState(false)

  const validationSchema = yup.object({
    newCoordinates: CoordinatesSchema,
  })

  const handleSubmitPreview = (values: {
    newCoordinates: string
    deliveryAreaLabel: string
  }) => {
    setIsLoadingCoordinates(true)
    if (values.newCoordinates.search(',') === -1) {
      return
    }
    const coordinatesToArray = values.newCoordinates.trim().split('\n')
    const coordinatesToNumber = coordinatesToArray.map((lat) => {
      return lat.split(',').map(Number)
    })
    setCoordinates([
      [
        {
          deliveryAreaGroupId: selectedDeliveryArea.id,
          area: coordinatesToNumber,
          deliveryAreaGroupName: selectedDeliveryArea.name,
          label: values.deliveryAreaLabel,
        },
      ],
    ])
    setIsLoadingCoordinates(false)
    setIsEditing(true)
    const resetDeliveryArea = { ...selectedDeliveryArea }
    setSelectedDeliveryArea(resetDeliveryArea)
    setImportVectorModal({ right: false })
  }

  const initialValues = {
    newCoordinates: '',
    deliveryAreaLabel: '',
  }

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={async (newCoordinates) => {
        handleSubmitPreview(newCoordinates)
      }}>
      {({ isValid, dirty, errors, submitForm }) => (
        <Modal
          showButton
          onButtonClick={submitForm}
          buttonIsDisabled={!isValid || !dirty}
          buttonText={t('preview')}
          isLoadingRequest={
            isLoadingCoordinates &&
            Boolean(coordinates) &&
            coordinates.length > 0
          }
          setModal={handleCloseVectorModal}
          modal={importVectorModal}
          title={t('serviceArea.newImportHeader')}
          subtitle={t('serviceArea.newImport-instructions')}>
          <Form>
            <Box>
              <Input
                label={t('deliveryAreaLabel')}
                name='deliveryAreaLabel'
                type='text'
                fullWidth
                variant='filled'
              />
              <Input
                errorMessage={errors.newCoordinates as string | undefined}
                label={t('serviceArea.inputCoordinates')}
                name='newCoordinates'
                type='text'
                multiline
                variant='filled'
                rows={20}
                fullWidth
                width='450px'
              />
            </Box>
          </Form>
        </Modal>
      )}
    </Formik>
  )
}
